import { put, call, all, takeLatest } from 'redux-saga/effects';
import { notification } from 'antd';
import get from 'lodash/get';
import { fetchPlantsSuccess, fetchPlantsFailure } from './action';
import { FETCH_PLANTS } from './types';
import adminAxiosConfig from '../../../services/adminAxiosConfig';

/** Get all listed equipments */
function* fetchPlants() {
  try {
    const res = yield adminAxiosConfig.get('/plants');
    const response = get(res, ['data', 'data'], {});
    if (res.status === 200) {
      yield put(fetchPlantsSuccess({ response }));
    } else {
      yield put(fetchPlantsFailure());
      notification.error({
        message: 'Something went wrong.',
      });
    }
  } catch (error) {
    yield put(fetchPlantsFailure());
    notification.destroy();
    notification.error({
      message: 'A problem occured while fetching the Plants Details.',
      description: `${error.error}`,
    });
  }
}

function* sowWatcher() {
  yield takeLatest(FETCH_PLANTS, fetchPlants);
}

function* plantSagas() {
  yield all([call(sowWatcher)]);
}

export default plantSagas;
